import { FIGURES } from "./figures";

/**
 * ============================================================================
 * The only way a number reaches a page — extracted 2026-08-30 (D-095).
 * ============================================================================
 *
 * It lived inside `Dashboard.tsx` while `/dashboard` was the only consumer.
 * The Home teasers are the second and third, and the brief that asked for them
 * asked for the same guarantee: **a teaser figure must join to a source or fail
 * the build.** A second copy of this component would be a second place that
 * guarantee can be quietly dropped, so there is one.
 *
 * It looks the id up in the registry `figures.ts` builds out of the content
 * layer, and it THROWS on a miss. `prerender.mjs` executes the component tree,
 * so an unregistered figure fails the build rather than shipping — which is the
 * whole mechanism: a number cannot be typed into a page, only named.
 *
 * `data-figure` carries the id into the markup so the join can be asserted
 * against the BUILT HTML from outside the app, in both directions (D-065).
 * Because Home now carries figures too, the sweep reads every document rather
 * than `/dashboard` alone.
 */
const Figure = ({ id, className }: { id: string; className?: string }): JSX.Element => {
	const value = FIGURES.get(id);
	if (value === undefined) {
		throw new Error(
			`Figure: no figure is registered for "${id}". Every number rendered through this component must be ` +
				"derived in src/components/pages/Dashboard/figures.ts — a figure typed into a page is a fabricated one."
		);
	}
	return (
		<span data-figure={id} className={className}>
			{value}
		</span>
	);
};

export default Figure;
